/* =============================================================================
 * CAFIDE · Bookmark de wishlist en TODAS las product cards del tema
 * -----------------------------------------------------------------------------
 * - Botón [data-cwk-fav] renderizado por snippets/product-card.liquid.
 * - Una sola instancia global, por delegación de eventos (vale para colección,
 *   búsqueda, relacionados, carruseles, quick view, scroll infinito...).
 * - Toggle añadir/quitar usando la API appmate (Swish/Wishlist King), igual que
 *   la sección best sellers.
 * - Marca el estado inicial leyendo /wishlists/mine (con reintentos) y al
 *   insertarse nuevas tarjetas (MutationObserver).
 * - Sincroniza con la página de wishlist, el cart-drawer y best sellers a través
 *   del evento 'cafide:wishlist:change'.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__cwkCardsInit) return;
  window.__cwkCardsInit = true;

  var SYNC_EVENT = 'cafide:wishlist:change';
  var SELF = 'theme-cards';

  /* ---------- estilos (una sola vez) ---------- */
  function injectStyles() {
    if (document.getElementById('cwk-fav-style')) return;
    var css =
      '.cwk-price-row{display:flex;align-items:center;justify-content:space-between;gap:10px;' +
        'width:100%;grid-column:1 / -1;justify-self:stretch;}' +
      '.cwk-price-row__price{min-width:0;}' +
      '.cwk-fav{-webkit-appearance:none;appearance:none;background:transparent;border:0;padding:0;margin:0;' +
        'cursor:pointer;color:currentColor;flex:0 0 auto;line-height:0;transition:opacity .15s ease;}' +
      '.cwk-fav:hover{opacity:.55;}' +
      '.cwk-fav svg{width:18px;height:18px;display:block;}' +
      '.cwk-fav[aria-pressed="true"] svg path{fill:currentColor;}' +
      /* el tema envuelve la info en rejillas centradas de ancho = contenido;
         estiramos solo las que contienen nuestra fila para que llegue al borde */
      '.product-card__info .v-stack:has(.cwk-price-row){width:100%;justify-items:stretch;}';
    var st = document.createElement('style');
    st.id = 'cwk-fav-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  /* ---------- API appmate (igual que best sellers) ---------- */
  function wlCreds() { var wk = window.WishlistKing; return wk && wk.apis && wk.apis.wishlist; }
  function wkRequest(creds, endpoint, method, payload) {
    var sid = (window.localStorage && localStorage.getItem('wk_session_id')) || '';
    var headers = Object.assign({}, creds.headers || {}, sid ? { 'x-appmate-sid': sid } : {});
    var opts = { method: method || 'GET', headers: headers, credentials: 'same-origin' };
    if ((method === 'POST' || method === 'DELETE') && payload) {
      if (!headers['Content-Type'] && !headers['content-type']) headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(payload);
    }
    return fetch(creds.host + endpoint, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var ct = r.headers.get('content-type') || '';
      return ct.indexOf('application/json') !== -1 ? r.json() : null;
    });
  }
  function getProductJson(handle) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return fetch(base + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function listWishlist() {
    var creds = wlCreds(); if (!creds) return Promise.resolve(null);
    return wkRequest(creds, '/wishlists/mine', 'GET')
      .then(function (d) { return (d && d.wishlist && d.wishlist.items) || (d && d.items) || []; })
      .catch(function () { return null; });
  }
  function addWishlist(handle, variantId) {
    var wk = window.WishlistKing;
    if (wk && typeof wk.addWishlistItem === 'function' && handle) {
      try {
        return Promise.resolve(wk.addWishlistItem({ productHandle: handle, variantId: variantId }))
          .then(function () { return true; })
          .catch(function () { return restAdd(handle, variantId); });
      } catch (e) { return restAdd(handle, variantId); }
    }
    return restAdd(handle, variantId);
  }
  function restAdd(handle, variantId) {
    var creds = wlCreds(); if (!creds) return Promise.resolve(false);
    return getProductJson(handle).then(function (p) {
      if (!p) return false;
      return wkRequest(creds, '/wishlists/mine/items', 'POST', {
        productId: p.id, variantId: variantId || (p.variants[0] && p.variants[0].id)
      }).then(function () { return true; }).catch(function () { return false; });
    });
  }
  function removeWishlistByProduct(handle, productId, variantId) {
    var creds = wlCreds(); if (!creds) return Promise.resolve();
    return listWishlist().then(function (items) {
      if (!items) return;
      var matches = items.filter(function (it) {
        return (productId && String(it.productId) === String(productId)) ||
               (variantId && String(it.variantId) === String(variantId));
      });
      return Promise.all(matches.map(function (it) {
        try { if (window.WishlistKing && typeof window.WishlistKing.removeWishlistItem === 'function') { window.WishlistKing.removeWishlistItem({ id: it.id }); } } catch (e) {}
        return wkRequest(creds, '/wishlists/mine/items', 'DELETE', { wishlistItemId: it.id }).catch(function () {});
      }));
    });
  }

  /* ---------- estado / marcado ---------- */
  var cache = null; /* { pids: {}, vids: {} } */
  function setMark(btn, on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }
  function setPressedByProduct(productId, variantId, on) {
    var sel = '[data-cwk-fav]';
    document.querySelectorAll(sel).forEach(function (b) {
      var pid = b.getAttribute('data-product-id'), vid = b.getAttribute('data-variant-id');
      if ((productId && String(pid) === String(productId)) || (variantId && String(vid) === String(variantId))) setMark(b, on);
    });
  }
  function applyMarks() {
    if (!cache) return;
    document.querySelectorAll('[data-cwk-fav]').forEach(function (b) {
      var pid = String(b.getAttribute('data-product-id'));
      var vid = String(b.getAttribute('data-variant-id'));
      setMark(b, !!cache.pids[pid] || !!cache.vids[vid]);
    });
  }
  function refreshCache() {
    return listWishlist().then(function (items) {
      if (!items) return null;
      var pids = {}, vids = {};
      items.forEach(function (it) { pids[String(it.productId)] = 1; vids[String(it.variantId)] = 1; });
      cache = { pids: pids, vids: vids };
      return cache;
    });
  }
  function markInitial(attempt) {
    attempt = attempt || 0;
    if (!wlCreds()) { if (attempt < 12) setTimeout(function () { markInitial(attempt + 1); }, 400); return; }
    refreshCache().then(function (c) {
      if (!c) { if (attempt < 12) setTimeout(function () { markInitial(attempt + 1); }, 400); return; }
      applyMarks();
    });
  }
  /* revalida contra el backend y re-aplica el estado real a TODAS las tarjetas.
     Si un add/remove no cuajó como esperábamos (p. ej. productos con varias tallas),
     el bookmark se autocorrige sin recargar. */
  var _reconcileT = null;
  function reconcile(delay) {
    if (_reconcileT) clearTimeout(_reconcileT);
    _reconcileT = setTimeout(function () {
      _reconcileT = null;
      refreshCache().then(function (c) { if (c) applyMarks(); });
    }, delay || 400);
  }

  /* ---------- sync entre secciones ---------- */
  function broadcast(detail) {
    try { window.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: Object.assign({ source: SELF }, detail) })); } catch (e) {}
  }
  window.addEventListener(SYNC_EVENT, function (e) {
    var d = e.detail || {}; if (d.source === SELF) return;
    (d.addedProductIds || []).forEach(function (pid) { if (cache) cache.pids[String(pid)] = 1; setPressedByProduct(pid, null, true); });
    (d.addedVariantIds || []).forEach(function (vid) { if (cache) cache.vids[String(vid)] = 1; setPressedByProduct(null, vid, true); });
    (d.productIds || []).forEach(function (pid) { if (cache) delete cache.pids[String(pid)]; setPressedByProduct(pid, null, false); });
    (d.variantIds || []).forEach(function (vid) { if (cache) delete cache.vids[String(vid)]; setPressedByProduct(null, vid, false); });
    reconcile();
  });

  /* ---------- click (delegación global) ---------- */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('[data-cwk-fav]');
    if (!fav) return;
    e.preventDefault();
    var handle = fav.getAttribute('data-handle');
    var pid = fav.getAttribute('data-product-id');
    var vidRaw = fav.getAttribute('data-variant-id');
    var vid = parseInt(vidRaw, 10) || 0;
    var pressed = fav.getAttribute('aria-pressed') === 'true';

    /* reflejar al instante en todas las tarjetas del mismo producto */
    setPressedByProduct(pid, vid, !pressed);

    if (!pressed) {
      if (cache) { cache.pids[String(pid)] = 1; if (vid) cache.vids[String(vid)] = 1; }
      addWishlist(handle, vid).then(function () {
        broadcast({ addedVariantIds: vid ? [vid] : [], addedProductIds: pid ? [pid] : [] });
        reconcile();
      });
    } else {
      if (cache) { delete cache.pids[String(pid)]; if (vid) delete cache.vids[String(vid)]; }
      removeWishlistByProduct(handle, pid, vid).then(function () {
        broadcast({ variantIds: vid ? [vid] : [], productIds: pid ? [pid] : [] });
        reconcile();
      });
    }
  });

  /* ---------- init + reaccionar a tarjetas nuevas ---------- */
  function boot() {
    injectStyles();
    markInitial(0);

    /* tarjetas insertadas después (scroll infinito, filtros, quick view, carruseles) */
    var pending = null;
    var mo = new MutationObserver(function (muts) {
      var hasNew = false;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { hasNew = true; break; }
      }
      if (!hasNew) return;
      if (pending) return;
      pending = setTimeout(function () { pending = null; applyMarks(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () { setTimeout(applyMarks, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();